<template>
  <div class="search-box">
    <van-search v-model="sVal" shape="round" clearable :placeholder="placeholder" :left-icon="require('@/styles/img/icon_search.png')" background="transparent" @search="onSearch"/>
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  props: ['sVal','placeholder'],
  data() {
    return {}
  },
  created () {
    console.log('sVal')
  },
  methods: {
    onSearch(val) {
      this.bus.$emit('svalue', {
        svalue: val
      })
    }
  },
  watch: {}
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SearchBar/index.vue